
import Loading from 'vux/src/components/loading/index.vue'

import { mapState } from 'vuex'
import wxwrapper from './assets/js/wxsdk-wrapper'

export default {
name: 'app',
components: {
Loading
},
data () {
return {
showLoading: false,
}
},
computed: {
...mapState([
'showMask',
])
},
mounted(){
this.computeLoading();
wxwrapper.config()




},
methods:{
computeLoading(){
if (this.showMask) {
setTimeout(() => {
if (this.showMask) {
this.showLoading = true;
} else {
this.showLoading = false;
}
}, 1000);
} else {
this.showLoading = false;
}
}
},
watch: {
showMask(newVal){
this.computeLoading()
}
}
}



// WEBPACK FOOTER //
// ./src/App.vue